import {SchemaDefinition} from '~/backend/src/connectors/db/dbDefinition/DbDefinitionMapperUtilities';

const schemaDefinition : SchemaDefinition = {
    tables: {
        cache  : {
            table          : 'CACHE',
            hasActiveView  : false,
            hasHistoryTable: false,
            hasHistoryView : false,
            hasView        : false,
            fieldMap       : {},
            historyFieldMap: {}
        },
        tmpFile: {
            table          : 'TMP_FILE',
            hasActiveView  : false,
            hasHistoryTable: false,
            hasHistoryView : false,
            hasView        : false,
            fieldMap       : {
                id              : 'FILE_ID',
                data            : 'FILE_DATA',
                modifierUserId  : 'FILE_MODIFIER',
                modificationTime: 'FILE_MODIFICATION_TIME'
            },
            historyFieldMap: {},
            fieldTypesMap  : {
                id              : 'INTEGER',
                data            : 'BYTEA',
                modifierUserId  : 'STRING',
                modificationTime: 'TIMESTAMP'
            }
        },
        log    : {
            table          : 'LOG',
            hasActiveView  : false,
            hasHistoryTable: false,
            hasHistoryView : false,
            hasView        : false,
            fieldMap       : {},
            historyFieldMap: {}
        }
    }
};

export default schemaDefinition;
